import { useLocalStorage } from '@vueuse/core'
import { buildDropeeStorageKey } from '@/config/config'

export const ongoingTap = useLocalStorage(buildDropeeStorageKey('tap.ongoing'), {
  count: 0,
  startTimestamp: 0,
  lastTapAvailableEnergy: 0,
})
